module.exports = __webpack_public_path__ + "img/carole-et-arnaud-1.c7b1abe2.jpg";